/**
 * MAP.STORE.TS
 */
import { createEntityStore } from "@/core/factory/store"
import { noContext } from "@/core/utils/noContext"
import { createEmptyMap, Map, MAP_ENTITY } from "./map.types"
import { order } from "./map.thunk"

const createMapStore = () => {
  const base = createEntityStore<Map, null>(MAP_ENTITY, createEmptyMap, noContext)

  return {
    ...base,
    selectors: base.selectors,
    thunks: {
      ...base.thunks,
      order
    }
  }
}

const mapStore = createMapStore()
export default mapStore
